//#region IMPORT
import React from 'react';
/** Components Import */
import {
  Stack,
  Box,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
  Divider,
  ListItemIcon,
  CardHeader,
  CardContent,
} from '@mui/material';
import { Button, Dialog } from '../../Components/MUIs';
import { StyledLabel, StyledTextField } from '../../Components/Ui/FormStyles';
/** Icons Import */
import {
  Lock as LockIcon,
  Notifications as AlarmSettingIcon,
  Logout as LogoutIcon,
  ArrowForwardIos as RightArrowIcon,
} from '@mui/icons-material';
//#endregion

function MyPage(props) {
  return (
    <Stack
      spacing={1}
      sx={{ bgcolor: '#ffffffff', height: 'calc(100vh - 124px)' }}
    >
      <Box sx={{ p: 1 }}>
        <Box
          sx={{
            boxShadow:
              '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
          }}
        >
          <CardHeader
            sx={{ mt: 2 }}
            titleTypographyProps={{
              textAlign: 'center',
              fontWeight: 700,
            }}
            title={
              props.lanInfo.length > 0
                ? props.lanInfo.filter((f) => f.lanId === 'MyPage')[0].lanNm // 내 정보
                : ''
            }
          />
          <CardContent>
            <List>
              <React.Fragment></React.Fragment>
              <React.Fragment>
                <ListItem sx={{ py: 1 }}>
                  <ListItemButton
                    sx={{
                      p: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                    onClick={() => props.setFindDialog(true)}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                        <LockIcon />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          props.lanInfo.length > 0
                            ? props.lanInfo.filter(
                                (f) => f.lanId === 'ChangePassword'
                              )[0].lanNm // 비밀번호 변경
                            : ''
                        }
                      />
                    </Box>
                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                      <RightArrowIcon
                        sx={{
                          ml: 2,
                          fontSize: '1rem',
                          color: '#000000',
                        }}
                      />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
                <Divider variant="middle" />
              </React.Fragment>
              <React.Fragment>
                <ListItem sx={{ py: 1 }}>
                  <ListItemButton
                    sx={{
                      p: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                    onClick={() => props.MovePage('/M_Alarm', '알림 설정')}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                        <AlarmSettingIcon />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          props.lanInfo.length > 0
                            ? props.lanInfo.filter(
                                (f) => f.lanId === 'AlarmSetting'
                              )[0]?.lanNm || '알림 설정'
                            : '알림 설정'
                        }
                      />
                    </Box>
                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                      <RightArrowIcon
                        sx={{
                          ml: 2,
                          fontSize: '1rem',
                          color: '#000000',
                        }}
                      />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
                <Divider variant="middle" />
              </React.Fragment>
              <React.Fragment>
                <ListItem sx={{ py: 1 }}>
                  <ListItemButton
                    sx={{
                      p: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                    onClick={() => props.LogoutLogic()}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                        <LogoutIcon />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          props.lanInfo.length > 0
                            ? props.lanInfo.filter(
                                (f) => f.lanId === 'Logout'
                              )[0].lanNm // 로그아웃(logout)
                            : ''
                        }
                      />
                    </Box>
                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                      <RightArrowIcon
                        sx={{
                          ml: 2,
                          fontSize: '1rem',
                          color: '#000000',
                        }}
                      />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              </React.Fragment>
            </List>
          </CardContent>
        </Box>
      </Box>
      <Dialog
        title={
          props.lanInfo.length > 0
            ? props.lanInfo.filter((f) => f.lanId === 'ChangePassword')[0].lanNm // 비밀번호 변경
            : ''
        }
        titleSx={{ fontWeight: 'bold', textAlign: 'center' }}
        open={props.findDialog}
        onClose={() => {
          props.setInputs({
            ...props.inputs,
            currentPassword: '',
            password: '',
            passwordConfirm: '',
          });
          props.setFindDialog(false);
        }}
        contentSx={{ display: 'flex', flexDirection: 'column' }}
        PaperProps={{ sx: { borderRadius: 4 } }}
        fullWidth
        useCloseButton={false}
        useSaveButton={false}
        closeButtonName={
          props.lanInfo.length > 0
            ? props.lanInfo.filter((f) => f.lanId === 'Close')[0].lanNm // 닫기
            : ''
        }
        saveButtonName={
          props.lanInfo.length > 0
            ? props.lanInfo.filter((f) => f.lanId === 'Confirm')[0].lanNm // 확인
            : ''
        }
        onSave={() => props.SaveLogic1()}
        maxWidth="sm"
        content={
          <Box sx={{ p: 1 }}>
            <Stack spacing={2}>
              <Box>
                <StyledLabel>
                  {props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.lanId === 'CurrentPassword'
                      )[0].lanNm // 현재 비밀번호
                    : ''}
                </StyledLabel>
                <StyledTextField
                  fullWidth
                  value={
                    props.inputs.currentPassword
                      ? props.inputs.currentPassword
                      : ''
                  }
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  type="password"
                />
              </Box>
              <Box>
                <StyledLabel>
                  {props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.lanId === 'Password')[0]
                        .lanNm // 비밀번호
                    : ''}
                </StyledLabel>
                <StyledTextField
                  fullWidth
                  value={props.inputs.password ? props.inputs.password : ''}
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      password: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  type="password"
                />
              </Box>
              <Box>
                <StyledLabel>
                  {props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.lanId === 'PasswordConfirm'
                      )[0].lanNm // 비밀번호 확인
                    : ''}
                </StyledLabel>
                <StyledTextField
                  fullWidth
                  value={
                    props.inputs.passwordConfirm
                      ? props.inputs.passwordConfirm
                      : ''
                  }
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      passwordConfirm: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  type="password"
                />
              </Box>
              {props.capsLockFlag && (
                <Typography variant="caption" color="red">
                  {`Caps Lock이 켜져 있습니다`}
                </Typography>
              )}
              <Typography
                variant="caption"
                sx={{
                  color: '#6B7280',
                }}
              >
                {`(영문, 숫자 포함 8자 이상으로 입력 해주세요.)`}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginY: 1.5,
                  marginX: 1,
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    marginX: 0.5,
                    width: '100%',
                    borderRadius: 2,
                    borderColor: '#E5E7EB',
                    color: '#111827',
                    '&:hover': {
                      borderColor: '#D1D5DB',
                      backgroundColor: '#F9FAFB',
                    },
                    '&:disabled': {
                      borderColor: '#E5E7EB',
                      color: '#9CA3AF',
                    },
                    fontSize: '15px',
                    padding: '0px, 20px, 0px, 20px',
                  }}
                  size="medium"
                  name={
                    props.lanInfo.length === 0
                      ? ''
                      : props.lanInfo.find(
                          (f) => f.lanType !== 'MENU' && f.lanId === 'Cancle'
                        ).lanNm //취소
                  }
                  onClick={() => {
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: '',
                      password: '',
                      passwordConfirm: '',
                    });
                    props.setFindDialog(false);
                  }}
                ></Button>
                <Button
                  sx={{
                    marginX: 0.5,
                    width: '100%',
                    borderRadius: 2,
                    backgroundColor: '#2CA900',
                    '&:hover': {
                      backgroundColor: '#2CA900', // hover 시 배경색
                    },
                    color: '#FFFFFF',
                    //height: "5vh",
                    fontSize: '15px',
                    padding: '0px, 20px, 0px, 20px',
                  }}
                  size="medium"
                  name={'저장'}
                  onClick={() => {
                    props.SaveLogic1();
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: '',
                      password: '',
                      passwordConfirm: '',
                    });
                  }}
                ></Button>
              </Box>
            </Stack>
          </Box>
        }
      />
    </Stack>
  );
}

export default MyPage;
